import { mapGetters, mapState, mapMutations } from 'vuex';
import axios from 'axios';
import formMixin from './formMixin';
import defaultMixin from './defaultMixin';

export default {
    mixins: [formMixin, defaultMixin],
    ...mapMutations('form', {setCsrf: 'setCsrf'}),
    methods: {
        calcPurchaseTotal(purchases) {
            let i, total;
            total = 0;
            for (i in purchases) {
                total += purchases[i].price * purchases[i].quantity;
            }
            return total;
        },
        getPurchaseValues(field, value) {
            if (['payments'].includes(field.integration) && !['creditcard','total'].includes(field.type)) {
                return this._purchaseValues(field, value);
            } else {
                return null;
            }
        },
        _purchaseValues(field, value) {
            let purchaseValue = {};
            if (field.product) {
                purchaseValue.price = field.product.price;
                purchaseValue.quantity = 1;
            }
            if (typeof value == 'object') {
                if (value.price) {
                    purchaseValue.price = value.price;
                    purchaseValue.quantity = value.quantity;
                } else if (field.options) {
                    let _values = [];
                    let name,quantity,price;
                    for (name in value) {
                        price = 0;
                        quantity = value[name];
                        field.options.forEach(function (option) {
                            if (option.value == name) {
                                price = option.price;
                            }
                        });
                        _values.push({price:price, quantity:quantity});
                    }
                    purchaseValue.price = this.calcPurchaseTotal(_values);
                    purchaseValue.quantity = 1;
                }
            } else if (field.integration_field_id == 'payments_UserDefined') {
                purchaseValue.price = value;
            } else {
                purchaseValue.quantity = value;
            }
            purchaseValue.id = field.id;
            if (purchaseValue.price) {
                purchaseValue.price = parseFloat(purchaseValue.price);
            }
            return purchaseValue;
        },
        addCreditCardError(message) {
            this.handleServerValidation({
                [this.creditCardField.id]: {
                    value: [message]
                }
            });
        },
        errorFromStripe(type, message) {
            if (type == 'card_error') {
                return message;
            } else {
                return 'An unexpected error occurred.  Please try again later.';
            }
        },
        getCustomerEmail() {
            let email = Object.values(this.$store.getters.response).find(field => field.fieldName === 'email');
            if (email) {
                return email.value;
            } else {
                return null;
            }
        },
        responseToMetaData() {
            let response = this.$store.getters.response;
            let metadata = {
                type: 'Form Submission',
                'form name': this.form.name,
            };
            Object.values(response).forEach((currentValue, key) => {
                if (currentValue.value && currentValue.fieldName != 'creditCard') {
                    let field = this.form.fields.find(field => field.id == currentValue.fieldId);
                    let name, value;
                    if (field) {
                        name = field.type+(key+1);
                        value = field.label.value + ": ";
                        if (field.type == 'payments_SingleProduct') {
                            if (parseInt(currentValue.value) <= 0) {
                                return;
                            }
                            value += currentValue.value + "x";
                        } else if (['payments_Checkbox', 'payments_Radio', 'payments_Dropdown'].includes(field.type)) {
                            let options = [];
                            let optionName;
                            for (optionName in currentValue.value) {
                                options.push(optionName + ' ('+currentValue.value[optionName]+'x)');
                            }
                            value += options.join(', ');
                        } else {
                            value += currentValue.value;
                        }
                    } else {
                        name = currentValue.fieldId;
                        value = currentValue.value;
                    }
                    metadata[name] = value;
                }
            });
            return metadata;
        },
        async prepareHandlePaymentBody(cc) {
            return {
                'customer': {
                    email: cc.value.email,
                    name: cc.value.name
                },
                'paymentIntent': {
                    'amount' : this.total,
                    'receipt_email': this.getReceiptEmail,
                    'currency': this.getCurrency,
                    'setup_future_usage': 'off_session',
                    'metadata': this.responseToMetaData(),
                    'description': this.responseToPaymentIntentDescription()
                },
                '_csrf': this.csrf,
                '_captcha': await this.getCaptchaResponse()
            };
        },
        async postHandlePayment(cc) {
            let body = await this.prepareHandlePaymentBody(cc);
            let params = {
                params: {
                    fieldId: this.creditCardField.id,
                    _sig : this.sig
                }
            };

            try {
                let response = await axios.post(`${this.domain}/forms/api/v1/forms/${this.formId}/integrations/payments/creditcard/prepare-payment`, body, params);

                return response.data;
            } catch (error) {
                return {message: error.response.data.message};
            }
        },
        responseToPaymentIntentDescription() {
            const maxChars = 350;
            let descriptionObjects = this._responseToDescriptionObjects(this.$store.getters.response, this.productFields);
            let totalLines = descriptionObjects.length;
            let maxPerLine = Math.floor(maxChars/descriptionObjects.length);
            let descriptions = descriptionObjects.map((description, key) => {
                return this._descriptionToLine(description, maxPerLine, (key +1) < totalLines);
            });
            return descriptions.join("\n");
        },
        _descriptionToLine(description, maxPerLine, newLine) {
            let descriptionString = this._descriptionToString(description, newLine);
            let totalLength = descriptionString.length + (newLine ? 1 : 0);
            if (totalLength > maxPerLine) {
                description.label = this._truncateDescriptionLabel(description.label, totalLength - maxPerLine);
                descriptionString = this._descriptionToString(description, newLine);
            }
            return descriptionString;
        },
        _descriptionToString(description) {
            let string = '';
            if (description.option === true) {
                string = "\t";
            }
            string += description.label;
            if (description.qty > 1) {
                string += " - " + description.qty + "x";
            }
            return string;
        },
        _truncateDescriptionLabel(label, charsRemove) {
            // We have to account for the elipsis
            charsRemove += 3;
            label = label.substr(0, label.length-charsRemove);
            if (label.charAt(label.length-1).search(/[^\w\d]/) != -1) {
                label = label.substring(0, (label.length-1));
            }
            label += "...";
            return label;
        },
        _responseToDescriptionObjects(response, productFields) {
            let fieldId;
            let productResponses = [];

            for (fieldId in response) {
                let productField = productFields.find(field => field.id == fieldId);
                if (productField) {
                    productResponses.push({
                        "label" : productField.label.value,
                        "qty"   : productField.integration_field_id === "payments_SingleProduct" ? response[fieldId].value : 1,
                        "option": false
                    });
                    if (productField.options.length > 0) {
                        let optionName;
                        for (optionName in response[fieldId].value) {
                            productResponses.push({
                                "label" : optionName,
                                "qty"   : response[fieldId].value[optionName],
                                "option": true
                            });
                        }
                    }
                }
            }

            return productResponses;
        },
        async confirmPayment(secret, ccData) {
            return this.stripe.base.confirmCardPayment(secret, {
                payment_method: {
                    card: this.stripe.elements.getElement('cardNumber'),
                    billing_details: {
                        name: ccData.value.name,
                        address: {
                            postal_code: ccData.value.zip
                        }
                    }
                }
            });
        }
    },
    computed: {
        ...mapState('form', ['form','formId']),
        ...mapState('payments', ['purchases', 'total', 'stripe', 'cardLoaded']),
        ...mapGetters('form', ['fieldByType', 'csrf']),
        ...mapGetters(['getFieldById', 'sig']),
        creditCardField() {
            return this.fieldByType('creditcard');
        },
        totalField() {
            return this.fieldByType('total');
        },
        productFields() {
            let fieldIds = ['payments_SingleProduct','payments_Radio','payments_Dropdown','payments_Checkbox','payments_UserDefined'];
            return this.form.fields.filter(field => fieldIds.includes(field.integration_field_id));
        },
        getCurrency() {
            return this.creditCardField.currency ? this.creditCardField.currency : 'usd';
        },
        getReceiptEmail() {
            let id = this.creditCardField.receiptEmail;
            if (id) {
                let response = this.getFieldById(id);
                if (response) {
                    return response.value;
                }
            } else {
                let email = this.fieldByType('email');
                if (email) {
                    let response = this.getFieldById(email.id);
                    if (response) {
                        return response.value;
                    }
                }
            }
            return null;
        }
    }
};
